import { BasePaginationResponseV2, BaseResponse, MessageResponse } from 'common/types/api'
import api from 'core/api'

import {
  CreateCategoryBody,
  ProductBody,
  UpdateStausVariable,
  UpdateStausWarehouseVariable,
  EditCategoryVariables,
  UploadImageProduct,
  EditProductVariables,
  CreateWarehouseBody,
  EditWarehouseVariables,
  ProductQuery,
  CreateInventoryStockBody,
  UpdateInventoryStockVariables,
  UpdateTransferWarehouseVariables,
  UpdateStockVariables,
  StockQuery,
  PagesQuery,
  Product,
  Category,
  Stock,
  StockHistory,
  Units,
  Image,
  Inventory,
  Warehouse,
  History,
  ProductInStockList,
  ProductV3Query,
  StockStatisticQuery,
  ProductV3,
  StockStatistic,
  ProductV3Detail,
  StockV3,
  StockV3Query,
  UpdateStockStatusV3Body,
  StockHistoryV3Query,
  StockHistoryV3,
  StockHistoryStatisticV3,
  InventorySettingGroup,
  UpdateInventorySettingsBody,
} from './type'

//category api
export const getCategory = (params?: PagesQuery) =>
  api.get<BasePaginationResponseV2<Category[]>>('/inventory/category', { params })

export const getProductCategory = () =>
  api.get<BaseResponse<Category[]>>('/inventory/category')

export const createCategory = (body: CreateCategoryBody) =>
  api.post<MessageResponse>('/inventory/category', body)

export const editCategory = ({ body, categoryId }: EditCategoryVariables) =>
  api.patch<MessageResponse>(`/inventory/category/${categoryId}`, body)

export const deleteCategory = (categoryId: string) =>
  api.delete<MessageResponse>(`/inventory/category/${categoryId}`)

//product api
export const getUnit = () => api.get<BaseResponse<Units[]>>('/units')

export const getProducts = (params?: ProductQuery) =>
  api.get<BasePaginationResponseV2<Product[]>>('/inventory/product', { params })

export const getProductsStock = (params?: ProductQuery) =>
  api.get<BasePaginationResponseV2<ProductInStockList[]>>('/inventory/stock/product', { params })

export const createProduct = (body: ProductBody) =>
  api.post<MessageResponse>('/inventory/product', body)

export const editProduct = ({ body, productId }: EditProductVariables) =>
  api.patch<MessageResponse>(`/inventory/product/${productId}`, body)

export const deleteProduct = (productId: string) =>
  api.delete<MessageResponse>(`/inventory/product/${productId}`)

export const getHistoryProductById = (productId: string, params?: PagesQuery) =>
  api.get<BasePaginationResponseV2<History[]>>(`/inventory/product/${productId}/history`, {
    params,
  })

export const getProductById = (productId: string) =>
  api.get<BaseResponse<Product>>(`/inventory/product/${productId}`)

export const uploadImageProduct = (body: UploadImageProduct | FormData) =>
  api.post<BaseResponse<Image>>('inventory/product/upload/image', body)

export const getCategoryById = (categoryId: string) =>
  api.get<BaseResponse<Inventory>>(`/inventory/category/${categoryId}`)

export const updateStatus = ({ body, productId }: UpdateStausVariable) =>
  api.patch<MessageResponse>(`/inventory/product/${productId}/status`, body)

//warehouse api
export const getWarehouse = (params?: PagesQuery) =>
  api.get<BasePaginationResponseV2<Warehouse[]>>('inventory/warehouse', { params })

export const createWarehouse = (body: CreateWarehouseBody) =>
  api.post<MessageResponse>('/inventory/warehouse', body)

export const editWarehouse = ({ body, warehouseId }: EditWarehouseVariables) =>
  api.patch<MessageResponse>(`/inventory/warehouse/${warehouseId}`, body)

export const deleteWarehouse = (warehouseId: string) =>
  api.delete<MessageResponse>(`/inventory/warehouse/${warehouseId}`)

export const updateStatusWarehouse = ({ body, warehouseId }: UpdateStausWarehouseVariable) =>
  api.patch<MessageResponse>(`/inventory/warehouse/${warehouseId}/status`, body)

//stock api
export const getStock = (params?: StockQuery) =>
  api.get<BasePaginationResponseV2<Stock[]>>('inventory/stock', { params })

export const getStockById = (stockId: string) =>
  api.get<BaseResponse<Stock>>(`inventory/stock/${stockId}`)

export const getHistoryStock = (params?: StockQuery) =>
  api.get<BasePaginationResponseV2<StockHistory[]>>('inventory/stock/history', { params })

export const createStock = (body: CreateInventoryStockBody) =>
  api.post<MessageResponse>('/inventory/stock', body)

export const updateStock = ({ body, stockId }: UpdateStockVariables) =>
  api.patch<MessageResponse>(`/inventory/stock/${stockId}`, body)

export const updateStockQuantity = ({ body, stockId }: UpdateInventoryStockVariables) =>
  api.patch<MessageResponse>(`/inventory/stock/${stockId}/quantity`, body)

export const updateProductIssue = ({ body, stockId }: UpdateInventoryStockVariables) =>
  api.patch<MessageResponse>(`/inventory/stock/${stockId}/product-issue`, body)

export const updateTransferWarehouse = ({ body, stockId }: UpdateTransferWarehouseVariables) =>
  api.patch<MessageResponse>(`/inventory/stock/${stockId}/warehouse-transfer`, body)

export const deleteStock = (stockId: string) =>
  api.delete<MessageResponse>(`/inventory/stock/${stockId}`)

export const getProductsV3 = (params?: ProductV3Query) =>
  api.get<BasePaginationResponseV2<ProductV3[]>>('/inventory/products', { params })

export const getStockStatistic = (params?: StockStatisticQuery) =>
  api.get<BaseResponse<StockStatistic>>('/inventory/products/stock-statistic', { params })

export const getProductV3ById = (productId: string) =>
  api.get<BaseResponse<ProductV3Detail>>(`/inventory/products/${productId}`)

export const getStocksV3 = (params?: StockV3Query) =>
  api.get<BasePaginationResponseV2<StockV3[]>>('/inventory/stocks', { params })

export const updateStockStatusV3 = (stockId: string, body: UpdateStockStatusV3Body) =>
  api.patch<MessageResponse>(`/inventory/stocks/${stockId}/status`, body)

export const getStockHistoryV3 = (params?: StockHistoryV3Query) =>
  api.get<BasePaginationResponseV2<StockHistoryV3[]>>('/inventory/stocks/history', { params })

export const getStockHistoryStatisticV3 = (params?: Omit<StockHistoryV3Query, 'transactionType' | 'pageSize' | 'page'>) =>
  api.get<BaseResponse<StockHistoryStatisticV3>>('/inventory/stocks/history/statistic/transaction-type', { params })

export const getInventorySettings = () =>
  api.get<BaseResponse<InventorySettingGroup[]>>('/inventory/settings')

export const updateInventorySettings = (body: UpdateInventorySettingsBody) =>
  api.patch<BaseResponse<InventorySettingGroup[]>>('/inventory/settings', body)
